module.exports = __webpack_public_path__ + "images/emoji/it.7e175662d4cd4ee33427.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/it.png
// module id = fL+y
// module chunks = 2